import { useEffect, useState } from 'react'
import { isPromoActive, PROMO_ENDS_AT } from '../lib/promo'

// Dry-cleaning promo — "send 3 shirts, the cheapest one is free".
//
// The offer ends after Nov 30 2026, Miami time (= Dec 1 05:00 UTC).
// The date lives here, in one place: when it passes, the banner
// disappears on its own, with no deploy and nothing to remember.
//
// NOTE: this only hides the MESSAGE. The discount itself is still
// applied by hand on the shirt line in the admin. If the automatic
// calculation ships later, it must read the same end date.
// The date moved to src/lib/promo.js so the pricing engine can read it
// without importing React. Re-exported here so the old import path still
// works — and so there is still exactly ONE date in the app.
export { PROMO_ENDS_AT, isPromoActive }

export default function PromoBanner() {
  // Decided after mount so a stale prerendered/cached page can never
  // keep showing an expired offer.
  const [show, setShow] = useState(false)
  useEffect(() => { setShow(isPromoActive()) }, [])
  if (!show) return null

  return (
    <div className="mb-5 w-full rounded-2xl border border-aqua/30 bg-aqua-soft px-4 py-3 text-center">
      <p className="text-[13px] font-extrabold text-navy">
        Send 3 shirts or more — the cheapest one is free.
      </p>
      <p className="mt-0.5 text-[11px] text-ink-2">
        Dry cleaning. Dress shirts &amp; polos. One per order. Through Nov 30.
      </p>
    </div>
  )
}
